import type { Mod } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const modResolver = createSimpleNamedExpressionResolver<Mod>(
  'mod',
  (dividend, divisor) => (divisor > 0 ? dividend % divisor : NaN)
);
